'use client'

import { SelectInput, useField, useFormFields } from '@payloadcms/ui';
import type { TextFieldClientProps } from 'payload';
import * as React from 'react';
import { RobotProvider } from '../../api/types';

type ProviderOption = {
  label: string;
  value: string;
};

export const LlmProvider: React.FC<TextFieldClientProps> = ({ path }) => {
  const appKey = useFormFields(
    ([fields]) => fields['settings.credentials.appKey']
  );
  const apiKey = useFormFields(
    ([fields]) => fields['settings.credentials.apiKey']
  );
  const { value, setValue } = useField<string>({ path });
  const [options, setOptions] = React.useState<ProviderOption[]>([]);

  const appKeyValue = appKey?.initialValue;
  const apiKeyValue = apiKey?.initialValue;

  React.useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await fetch(
          (process.env.PAYLOAD_PUBLIC_BASE_PATH || '') +
          '/api/llm/providers?locale=it',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            referrer: '',
            body: JSON.stringify({
              appKey: appKeyValue,
              apiKey: apiKeyValue,
            }),
          }
        );
        if (response.ok) {
          const providers = (await response.json()) as RobotProvider[];
          const options: ProviderOption[] = providers
            .map((provider) => ({
              label: provider.value,
              value: provider.id,
            }))
            .sort((a, b) => a.label.localeCompare(b.label));
          setOptions(options);
        } else {
          setOptions([{ label: (await response.json()).message, value: '' }]);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    if (appKeyValue && apiKeyValue) {
      fetchOptions();
    }
  }, [appKeyValue, apiKeyValue]);

  return (
    <div className="field-type select">
      <label
        className="field-label"
        htmlFor={`field-${path}`.replace(/\./g, '__')}
      >
        Provider
      </label>
      <SelectInput
        path={path}
        name={path}
        options={options}
        value={value}
        hasMany={false}
        onChange={(option) => Array.isArray(option) ? null : setValue(option.value)}
      />
    </div>
  );
};
